@let vm = vm$();

<div class="p-24 h-100 w-100 flex-col gap-16">
  @if (vm.viewState !== 'LOADING' && vm.viewState !== 'INITIAL_EMPTY') {
  <div class="flex-row space-between-start">
    <div class="flex-col gap-16">
      <ui-search [placeholder]="'VARIABLES.PLACEHOLDERS.SEARCH' | translate"
                 [searchQuery]="vm.searchQuery"
                 style="width: 285px"
                 (searchQueryChange)="searchQuery.set($event)">
      </ui-search>
    </div>
    <ui-button type="secondary"
               [text]="'VARIABLES.BUTTONS.CREATE' | translate"
               (clickAction)="createNewVariable()">
    </ui-button>
  </div>
  }

  @switch (vm.viewState) {
  @case ('LOADING') {
  <div class="h-100 w-100 flex-col center-center">
    <ui-preloader [color]="loaderColor.blue"></ui-preloader>
  </div>
  }
  @case ('INITIAL_EMPTY') {
  <div class="h-100 w-100 flex-col center-center">
    <ui-no-data [imgSrc]="noData.imgSrc"
                [title]="noData.title | translate"
                [createButtonText]="noData.createButtonText | translate"
                (onCreate)="createNewVariable()">
    </ui-no-data>
  </div>
  }
  @case ('NO_RESULTS') {
  <div class="h-100 w-100 flex-col center-center">
    <ui-no-data [imgSrc]="noResults.imgSrc"
                [title]="noResults.title | translate"></ui-no-data>
  </div>
  }
  @case ('HAS_DATA') {
  @if (tableConfig()) {
  <ui-dataset-table [data]="vm.filteredVariables"
                    [config]="tableConfig()!"
                    (rowAction)="onRowAction($event)"></ui-dataset-table>
  }
  }
  }
</div>

<!-- CELL TEMPLATES -->
<ng-template #typeCell
             let-row>
  <div class="type-chip">
    {{ formatVariableType(row.type) }}
  </div>
</ng-template>

<ng-template #valueCell
             let-row>
  <div class="flex-row start-center">
    @if (row.type === 'json') {
    <ui-button iconClass="ui-icon-eye"
               type="default"
               (clickAction)="viewJson(row.value)">
    </ui-button>
    } @else {
    <div class="value-chip">{{ row.value }}</div>
    }
  </div>
</ng-template>